export { default as ImageDancingDog } from './loader.gif';
